export function normalizePhoneSearchTerm(search: string): string {
  if (!/^[\d\s+/()-]+$/.test(search.trim())) return search;

  // The API matches substrings, so dropping the German country/trunk prefix finds "+49…" and "0…" numbers alike.
  return (
    search
      .replace(/[^\d+]/g, "")
      .replace(/^(\+49|0049)?0*/, "")
      .replace(/\D/g, "") || search
  );
}
